import { Request } from '@/utils/axios/request';

// 登陆
export function login(params, extra) {
  return Request.http.post('/login', params, extra);
}

//云之家登录
export function yzjLogin(params, extra) {
  return Request.http.post('/yzj/yzjUserLoginPC', params, extra);
}

// 退出
export function logout(params, extra) {
  return Request.http.post('/logout', params, extra);
}

// 注册
export function register(params, extra) {
  return Request.http.post('/register', params, extra);
}

// 修改密码
export function changepwd(params, extra) {
  return Request.http.post('/password/changePassword', params, extra);
}

//修改密码
export function updatePassword(params, extra) {
  return Request.http.post('/updatePassword', params, extra);
}

//获取menu
export function getMenu(params, extra) {
  return Request.http.get('/index/menus', params, extra);
}
//组织机构懒加载
export function querySubOrgList(params, extra) {
  return Request.http.get('/organize/querySubOrgList', params, extra);
}


// 手机号搜索所有注册用户
export function getUserByPhone(params, extra) {
  return Request.http.get('/user/queryUserDtoByMobile', params, extra);
}

// 人员邀请的搜索接口---通过手机号精确搜索
export function selectByTelephone(params, extra) {
  return Request.http.get('/tenant-user/selectByTelephone', params, extra);
}


//查询当前企业开通的产品信息
export function getSystemMenu(params, extra) {
  return Request.http.post('/system/querySystem', params, extra);
}


// 获取组织下的人员列表
export function getCurrentUserListByOrgId(params, extra) {
  return Request.http.post('/user/search', params, extra);
}

// 获取个人信息
export function getUserInfo(params, extra) {
  return Request.http.get('/user/getUserInfo', params, extra);
}

// 新增/修改项目
export function addProj(params, extra) {
  return Request.http.post('/proj/save', params, extra);
}

// 删除项目
export function delProj(params, extra) {
  return Request.http.get('/proj/delete', params, extra);
}

// 获取项目
export function projList(params, extra) {
  return Request.http.get('/proj/searchList', params, extra);
}

// 获取项目详情
export function projInfo(params, extra) {
  return Request.http.get('/proj/getProjInfo', params, extra);
}

// 获取公司列表
export function getTenantInfo(params, extra) {
  return Request.http.get('/tenant/getTenantInfo', params, extra);
}

// 获取项目类型
export function getDistListInfo(params, extra) {
  if (params) {
  } else {
    params = {};
  }
  params.distGrp = 1033;
  return Request.http.get('/comm/getDistListInfo', params, extra);
}

//获取公司组织架构
export function getOrganizeTree(params, extra) {
  return Request.http.get('/organize/search', params, extra);
}

//导出人员管理
export function excelPerManagementReportExport(params, extra) {
  return Request.http.post('/tenant-user/excelPerManagementReport-excel', params, extra);
}


//分页查询流程模版
export function getTemplateProcess(params, extra) {
  return Request.http.post('/workflow/process/findTemplateProcess', params, extra);
}

//查询当前用户能管理的审批流程
export function getCanAdminProcess(params, extra) {
  return Request.http.post('/workflow/process/queryCanAdminProcess', params, extra);
}

//根据公司id分页查询流程
export function getTaskByComplanyId(params, extra) {
  return Request.http.post('/workflow/process/findByComplanyId', params, extra);
}

//获取流程定义xml的url
export function getProcessDefDetail(params, extra) {
  return Request.http.get('/workflow/process/getProcessDefDetail', params, extra);
}

//获取服务任务的事件列表
export function getTaskCallbackInfo(params, extra) {
  return Request.http.get('/workflow/process/queryCallbackInfo', params, extra);
}

//发布、保存流程定义
export function submitTask(params, extra) {
  return Request.http.post('/workflow/process/deployByString', params, extra);
}

//删除流程定义
export function deleteTask(params, extra) {
  return Request.http.post('/workflow/process/deleteProcessDef', params, extra);
}

//启用流程定义
export function startTask(params, extra) {
  return Request.http.get('/workflow/process/startUseProcessDef', params, extra);
}

//停用流程定义
export function stopTask(params, extra) {
  return Request.http.get('/workflow/process/stopUseProcessDef', params, extra);
}

//查询邀请用户入驻的key
export function getInviteUserKey(params, extra) {
  return Request.http.get('/workflow/process/querySolidifyProcess', params, extra);
}

//获取起始表单
export function getStartTask(params, extra) {
  return Request.http.get('/workflow/process/getProcessStartForm', params, extra);
}

//开始流程
export function startTaskForm(params, extra) {
  return Request.http.post('/workflow/process/startProcessInstance', params, extra);
}


//完善企业信息
export function compleTenantInfo(params, extra) {
  return Request.http.post('/tenant-register/compleTenantInfo', params, extra);
}

//注册企业
export function registerTenant(params, extra) {
  return Request.http.post('/tenant-register/save', params, extra);
}

//重置密码
export function resetPassword(params, extra) {
  return Request.http.post('/resetPassword', params, extra);
}


//切换企业
export function switchCompany(params, extra) {
  return Request.http.get('/switchTokenInfo', params, extra);
}

//删除企业
export function delOrganize(params, extra) {
  return Request.http.get('/organize/delete', params, extra);
}

//切换用户组织机构
export function updateOrganize(params, extra) {
  return Request.http.post('/organize/updateOrganize', params, extra);
}

//添加组织结构
export function addOrgnaize(params, extra) {
  return Request.http.post('/organize/save', params, extra);
}

//通过组织id获取主管
export function getMasterByOId(params, extra) {
  return Request.http.get('/organize-user/selectOrganizeChargePersonInfo', params, extra);
}

//查询用户所在的企业的所有组织及所属组织列表
export function moveOrganizeInfosOfUser(params, extra) {
  return Request.http.get('/organize-user/moveOrganizeInfosOfUser', params, extra);
}

//人员调动
export function batchMovePersonnel(params, extra) {
  return Request.http.post('/organize-user/batchMovePersonnel', params, extra);
}

// 获取组织结构
export function getOrganizeList(params, extra) {
  return Request.http.get('/organize/search', params, extra);
}

// 获取某组织下的人员信息
export function searchOrgaTreeOfUser(params, extra) {
  return Request.http.get('/organize/searchOrgaTreeOfUser', params, extra);
}

//获取组织架构可以使用的管理层级类型
export function getOrganizeType(params, extra) {
  return Request.http.get('/organize/queryOrgTypeList', params, extra);
}

// 新增/修改组织
export function organizeSave(params, extra) {
  return Request.http.post('/organize/save', params, extra);
}

// 删除组织
export function organizeDel(params, extra) {
  return Request.http.get('/organize/delete', params, extra);
}

//根据组织id删除组织结构
export function deleteOrganize(params, extra) {
  return Request.http.get('/organize/delete', params, extra);
}

//发送注册验证码
export function sendCode(params, extra) {
  return Request.http.get('/sendRegisterMsg', params, extra);
}

//发送注册验证码
export function sendResetPwdVerifyCode(params, extra) {
  return Request.http.get('/sendVerifyCodeLoginMsg', params, extra);
}

//发送重置密码验证码
export function sendPwdResetCodeMsg(params, extra) {
  return Request.http.get('/sendPwdResetCodeMsg', params, extra);
}

//查询项目列表
export function selectProjectList(params, extra) {
  return Request.http.post('/proj/selectProjectPage', params, extra);
}

//查询项目详情
export function getProjectInfo(params, extra) {
  return Request.http.get('/proj/getProjInfo', params, extra);
}

//编辑项目详情
export function saveProjectInfo(params, extra) {
  return Request.http.post('/proj/save', params, extra);
}

//删除项目
export function deleteProject(params, extra) {
  return Request.http.get('/proj/delete', params, extra);
}


//分页查询供应商列表
export function getSupplierList(params, extra) {
  return Request.http.post('/supplier/selectSupplierPage', params, extra);
}

//查询供应商详情
export function getSupplierInfo(params, extra) {
  return Request.http.get('/supplier/supplierDetail', params, extra);
}

//保存供应商信息
export function saveSupplier(params, extra) {
  return Request.http.post('/supplier/supplierUpdate', params, extra);
}


//查询企业下用户列表
export function getChompanyUserList(params, extra) {
  return Request.http.post('/tenant-user/userPageList', params, extra);
}


//设置主管
export function setMaster(params, extra) {
  return Request.http.post('/tenant-user/setOrganizeChargePerson', params, extra);
}

//人员离职
export function departure(params, extra) {
  return Request.http.get('/tenant-user/departure', params, extra);
}

//将人员移除某个组织
export function removeUserForOrgnaize(params, extra) {
  return Request.http.get('/tenant-user/RemoveUserFromOrganize', params, extra);
}

//查询某个企业用户信息
export function queryTenantUserInfo(params, extra) {
  return Request.http.get('/tenant-user/queryTenantUserInfo', params, extra);
}

//查询多个userid的info
export function getUserInfoByUserIds(params, extra) {
  return Request.http.get('/user/queryUserInfosByUserIds', params, extra);
}


//修改用户信息
export function modifyTenantUserInfo(params, extra) {
  return Request.http.post('/tenant-user/modifyTenantUserInfo', params, extra);
}

//批量邀请用户入住
export function batchesInviteUsers(params, extra) {
  return Request.http.post('/tenant-user/batchesInviteUsers', params, extra);
}

//以当前用户所在组织机构为顶点，获取组织机构树
export function getUserOrgTree(params, extra) {
  return Request.http.get('/tenant-register/queryTenantUserOrganize', params, extra);
}

//分页查询企业下职位列表
export function getJobmanageList(params, extra) {
  return Request.http.post('/position/queryTenantPositonPage', params, extra);
}

//分页查询组织机构下的职位列表
export function getPositionByOrganizeList(params, extra) {
  return Request.http.post('/position/queryOrganizeIdPositonPage', params, extra);
}


//启用禁用职位
export function openJobmanage(params, extra) {
  return Request.http.get('/position/updateStatus', params, extra);
}

//获取企业系统功能列表
export function getSysOptionsList(params, extra) {
  return Request.http.get('/position/querySysFunction', params, extra);
}

//保存职位信息
export function savePosition(params, extra) {
  return Request.http.post('/position/createPosition', params, extra);
}

//获取职位详情
export function getPositionInfo(params, extra) {
  return Request.http.get('/position/queryCustomPositon', params, extra);
}

//删除职位
export function deletePosition(params, extra) {
  return Request.http.get('/position/deletePositon', params, extra);
}

//导入默认职位配置
export function importDefaultPosition(params, extra) {
  return Request.http.get('/position/importDefaultConfig', params, extra);
}

//查询组织职位人员列表
export function queryUsersOfOrgPositon(params, extra) {
  return Request.http.get('/position/queryUsersOfOrgPositon', params, extra);
}

//职位用户关系绑定
export function bindUserPosition(params, extra) {
  return Request.http.post('/position/bindUserPosition', params, extra);
}

//流程引擎根据组织id、职位id获取职位详情   参数 1#2,1#3,1#4,2#1
export function queryPositionInfoByOrgIdAndPosId(params, extra) {
  return Request.http.get('/position/queryPositionInfoByOrgIdAndPosId', params, extra);
}


//获取项目列表
export function getProjectList(params, extra) {
  return Request.http.get('/user/managerProjects', params, extra);
}

//获取工作分解结构树
export function getWorkStructureTree(params, extra) {
  return Request.http.get('/workResolve/getWorkSubNodeList', params, extra);
}

//启用、禁用工作分解结构
export function enabledWorkResolveNode(params, extra) {
  return Request.http.get('/workResolve/enabledWorkResolveNode', params, extra);
}

//解锁、锁定工作分解结构
export function lockWorkResolveNode(params, extra) {
  return Request.http.get('/workResolve/lockWorkResolveNode', params, extra);
}

//删除工作分解结构
export function deleteWorkResolveNode(params, extra) {
  return Request.http.get('/workResolve/deleteWorkResolveNode', params, extra);
}

//新增工作分解结构
export function addWorkNode(params, extra) {
  return Request.http.post('/workResolve/addWorkNode', params, extra);
}

//编辑工作分解结构
export function editWorkNode(params, extra) {
  return Request.http.post('/workResolve/editWorkNode', params, extra);
}

//获取可选的工作性质列表
export function queryWorkNatureListByPid(params, extra) {
  return Request.http.get('/workResolve/queryWorkNatureListByPid', params, extra);
}

//保存下级工作性质
export function setDownWorkNature(params, extra) {
  return Request.http.get('/workResolve/setDownWorkNature', params, extra);
}


//获取工程量清单树
export function queryEngineeringListTree(params, extra) {
  return Request.http.get('/engineeringListing/queryEngineeringList', params, extra);
}

//启用、禁用工程量清单
export function enabledEngineeringList(params, extra) {
  return Request.http.get('/engineeringListing/disableEnable', params, extra);
}

//解锁、锁定工程量清单
export function lockEngineeringList(params, extra) {
  return Request.http.get('/engineeringListing/lockDownAndUnlock', params, extra);
}

//删除工程量清单
export function deleteEngineeringList(params, extra) {
  return Request.http.get('/engineeringListing/deleteEngineeringList', params, extra);
}

//新增工程量清单
export function addEngineeringList(params, extra) {
  return Request.http.post('/engineeringListing/addEngineering', params, extra);
}

//编辑工程量清单
export function editEngineeringList(params, extra) {
  return Request.http.post('/engineeringListing/modifyEngineering', params, extra);
}

//查询工程量清单
export function queryDownEngineeringListById(params, extra) {
  return Request.http.get('/zeroLedger/queryDownEngineeringListById', params, extra);
}

//挂接零号台账
export function saveHookList(params, extra) {
  return Request.http.post('/zeroLedger/saveHookList', params, extra);
}

//获取零号台账右侧表格树
export function getZeroLedgerSubNodeList(params, extra) {
  return Request.http.get('/zeroLedger/getZeroLedgerSubNodeList', params, extra);
}

//导入工程量清单模版
export function importBoqTemplate(params, extra) {
  return Request.http.get('/engineeringListing/importTemplate', params, extra);
}

//删除零号台账
export function deleteZeroLedgerList(params, extra) {
  return Request.http.get('/zeroLedger/deleteZeroLedgerList', params, extra);
}

//锁定解锁零号台账
export function lockZeroLedgerList(params, extra) {
  return Request.http.get('/zeroLedger/lockZeroLedgerList', params, extra);
}

//编辑零号台账
export function editZeroLedgerList(params, extra) {
  return Request.http.post('/zeroLedger/editZeroLedgerList', params, extra);
}

// //查询零号台账详情
// export function getZeroLedgerListDetail(params, extra) {
//   return Request.http.get('/zeroLedger/queryZeroLedgerData', params, extra);
// }

//获取最新版本号
export function getLastVersion(params, extra) {
  return Request.http.get('/versionManager/queryLastVersion', params, extra);
}

//提交流程引擎的起始表单json
export function taskFormUpload(params, extra) {
  return Request.http.post('/workflow/form/formUpload', params, extra);
}

//获取当前用户所在的所有组织架构节点
export function getCurrentUserOrgTrees(params, extra) {
  return Request.http.get('/organize/getCurrentUserOrgTree', params, extra);
}


//查询大屏项目列表
export function getManagerProjects(params, extra) {
  return Request.http.get('/data-visualization/index/managerProjects', params, extra);
}

//查询大屏项目及人员信息
export function getPersonnelInfo(params, extra) {
  return Request.http.get('/data-visualization/projectAndPersonnelInformation/queryProjectAndPersonnelInformation', params, extra);
}

//设备信息数量统计
export function deviceBoardTotal(params, extra) {
  return Request.http.get('/data-visualization/deviceInformation/queryDeviceInformation', params, extra);
}

// 设备工作台班
export function deviceEquipmentWorkTeam(params, extra) {
  return Request.http.get('/data-visualization/deviceInformation/queryEquipmentWorkTeam', params, extra);
}

// 车辆设备定位地图信息
export function deviceMapInformation(params, extra) {
  return Request.http.get('/data-visualization/deviceInformation/queryDevicePotion', params, extra);
}
// 车辆设备轨迹
export function findByDevIdDevTrajectory(params, extra) {
  return Request.http.get('/data-visualization/deviceInformation/findByDevIdDevTrajectory', params, extra);
}

//大屏公告和日志
export function getAnnouncementLog(params, extra) {
  return Request.http.get('/data-visualization/announcementAndLog/queryAnnouncementAndLog', params, extra);
}

//大屏油料信息
export function oilInformation(params, extra) {
  return Request.http.get('/data-visualization/oilInformation/queryOilInformation', params, extra);
}

//油料地图数据看板
export function oilMapInformation(params, extra) {
  return Request.http.get('/data-visualization/oilInformation/queryOilDataKanBan', params, extra);
}
//油料地图数据详情
export function oilMapDetails(params, extra) {
  return Request.http.get('/data-visualization/oilInformation/queryOilInAndOutInformation', params, extra);
}

//大屏混凝土节超
export function concreteSectionSuper(params, extra) {
  return Request.http.get('/data-visualization/sectionExceedingQuantity/queryConcreteSectionExceedingQuantity', params, extra);
}

//大屏钢材库房节超
export function steelSectionSuper(params, extra) {
  return Request.http.get('/data-visualization/sectionExceedingQuantity/querySiteWarehouse', params, extra);
}

//查询油罐列表
export function queryOilList(params, extra) {
  return Request.http.get('/data-visualization/oilInformation/queryOilList', params, extra);
}

//项目切换
export function switchProjectInfo(params, extra) {
  return Request.http.get('/data-visualization/index/switchProjectInfo', params, extra);
}

//推送报警信息
export function pushAlarmMessage(params, extra) {
  return Request.http.get('/data-visualization/pushAlarmMessage/queryPushAlarmMessage', params, extra);
}

//公告及日志
export function announcementAndLog(params, extra) {
  return Request.http.get('/data-visualization/announcementAndLog/queryAnnouncementAndLog', params, extra);
}

//查询钢材库房列表
export function querySteelStoreroomList(params, extra) {
  return Request.http.get('/data-visualization/steelInformation/querySteelWarehouseList', params, extra);
}

//钢材台账-节超
export function querySteelFugalNumer(params, extra) {
  return Request.http.get('/data-visualization/steelInformation/querySteelFugalNumer', params, extra);
}
//查询钢材信息
export function steelInformation(params, extra) {
  return Request.http.get('/data-visualization/steelInformation/querySteelInformation', params, extra);
}
//查询地图钢材信息
export function steelMapInformation(params, extra) {
  return Request.http.get('/data-visualization/steelInformation/querySteelWarehouseInformation', params, extra);
}

//查询当前项目下混凝土所有站点
export function queryConcreteStoreroomList(params, extra) {
  return Request.http.get('/data-visualization/concreteInformation/getMixingStationByProjIds', params, extra);
}

//查询当前项目下混凝土所有站点地图数据
export function concreteMapList(params, extra) {
  return Request.http.get('/data-visualization/concreteInformation/getMixingStationByProjIds', params, extra);
}

//地图--查询该站点的混泥土数据
export function concreteMapDetail(params, extra) {
  return Request.http.get('/data-visualization/concreteInformation/queryStationStockPage', params, extra);
}

//查询该站点下的混凝土数据
export function concreteStoreroomInformation(params, extra) {
  return Request.http.get('/data-visualization/concreteInformation/queryStationStockPage', params, extra);
}

// 查询站点下最近七日的每日的出库量
export function queryStationStock(params, extra) {
  return Request.http.get('/data-visualization/concreteInformation/queryStationStock', params, extra);
}

//查询磅房位置列表
export function queryWeighingInformationList(params, extra) {
  return Request.http.get('/data-visualization/materialWeighingInformation/getStidBindByProjIds', params, extra);
}

//物料称重数据统计
export function materialWeighingInformation(params, extra) {
  return Request.http.get('/data-visualization/materialWeighingInformation/countGroupByWz', params, extra);
}

// 物料称重信息地磅物资统计
export function materialWeighingGys(params, extra) {
  return Request.http.get('/data-visualization/materialWeighingInformation/countGroupByGys', params, extra);
}
// 物料称重信息 地图
export function materialWeighingMap(params, extra) {
  return Request.http.get('/data-visualization/materialWeighingInformation/getTrainsAndWeightByStationId', params, extra);
}
// 地磅供应商选择
export function weightSupplierChoice(params, extra) {
  return Request.http.get('/data-visualization/materialWeighingInformation/querySupplierList', params, extra);
}
// 混凝土配合比列表
export function concreteFormulaList(params, extra) {
  return Request.http.post('/concreteFormula/list', params, extra);
}
// 获取混凝土砼标号列表
export function concreteDictByCode(params, extra) {
  return Request.http.get('/dict/queryDictTreeByCode', params, extra);
}
// 获取混凝土物资名称和物资规格
export function concreteQueryTwoLevelDictTreeByCode(params, extra) {
  return Request.http.get('/dict/queryTwoLevelDictTreeByCode', params, extra);
}
// 修改混凝土砼配合比
export function concreteFormulaUpdate(params, extra) {
  return Request.http.post('/concreteFormula/update', params, extra);
}
// 获取混凝土砼配合比详情
export function concreteFormulaViewDetail(params, extra) {
  return Request.http.get('/concreteFormula/view', params, extra);
}
// 删除混凝土砼配合比
export function concreteFormulaDelete(params, extra) {
  return Request.http.get('/concreteFormula/delete', params, extra);
}
// 批量新增混凝土砼配合比
export function concreteFormulaAddBatch(params, extra) {
  return Request.http.post('/concreteFormula/addBatch', params, extra);
}

//获取砼配合比分页列表 (新)
export function queryConcreteFormulaPage(params, extra) {
  return Request.http.post('/concreteFormula/queryConcreteFormulaPage', params, extra);
}

//获取砼配合比详情（新）
export function queryInfoByConcreteGradeId(params, extra) {
  return Request.http.get('/concreteFormula/queryListByConcreteGradeId', params, extra);
}

//删除砼配合比（新）
export function deleteByConcreteGradeId(params, extra) {
  return Request.http.get('/concreteFormula/deleteByConcreteGradeId', params, extra);
}

//获取物资字典树 混凝土（新）
export function materialDictionaryTree(params, extra) {
  return Request.http.get('/dict/materialDictionaryTree', params, extra);
}


// 删除外部供应商
export function deleteSupplier(params, extra) {
  return Request.http.get('/supplier/deleteSupplier', params, extra);
}

// 报表设计器 获取报表列表
export function getReportFormTemplateList(params, extra) {
  return Request.http.get('/report-form-design/designSys/getTemplateList', params, extra);
}
// 报表设计器 删除模版
export function delReportFormTemplate(params, extra) {
  return Request.http.get('/report-form-design/designSys/delTemplate', params, extra);
}
// 报表设计器 查询模版条件
export function getTemplateCondition(params, extra) {
  return Request.http.get('/report-form-design/designSys/getTemplateCondition', params, extra);
}
// 报表设计器 获取当前用户可管理的项目列表
export function getUserManageProject(params, extra) {
  return Request.http.get('/report-form-design/user/managerProjects', params, extra);
}
//报表设计器 发布到项目
export function applyToProject(params, extra) {
  return Request.http.post('/report-form-design/designSys/publishToProject', params, extra);
}
//报表设计器 同步导出Excel
export function reportFormExportExcel(params, extra) {
  return Request.http.post('/report-form-design/report/exportExcel', params, extra);
}
//报表设计器 同步导出Excel
export function reportFormExportAsyncExcel(params, extra) {
  return Request.http.post('/report-form-design/report/doExportExcel', params, extra);
}
//报表设计器 根据企业id、系统code获取报表分组
export function getReportFormGroupBySys(params, extra) {
  return Request.http.get('/report-form-design/designSys/getTenantTemplateGroups', params, extra);
}
//报表设计器 新建分组
export function createReportFormGroup(params, extra) {
  return Request.http.post('/report-form-design/designSys/modifyTemplateGroup', params, extra);
}
//报表设计器 删除分组
export function deleteReportFormGroup(params, extra) {
  return Request.http.get('/report-form-design/designSys/delTemplateGroup', params, extra);
}
//报表设计器 移动分组
export function moveReportFormGroup(params, extra) {
  return Request.http.get('/report-form-design/designSys/moveTemplateGroup', params, extra);
}
//报表设计器 获取当前用户可管理的组织架构树
export function getReportFormManagerLevelOrgTree(params, extra) {
  return Request.http.get('/report-form-design/user/queryManagerLevelOrgTree', params, extra);
}
//报表设计器 保存编辑管理层级
export function saveReportFormTemplateOrg(params, extra) {
  return Request.http.get('/report-form-design/designSys/modifyTemplateOrg', params, extra);
}
//报表设计器 根据模版管理层级组织id获取可发布的项目列表
export function getManagerProjectsByOrgId(params, extra) {
  return Request.http.get('/report-form-design/designSys/getManagerProjectsByOrgId', params, extra);
}
//报表设计器 获取用户可导出报表的项目列表
export function getUserProjectsOfTemplate(params, extra) {
  return Request.http.get('/report-form-design/user/userProjectsOfTemplate', params, extra);
}






//物料字典 获取物料字典树
export function getMaterialDictionaryTree(params, extra) {
  return Request.http.get('/materialdictionary/tree', params, extra);
}
//物料字典 获取物料字典树（懒加载）
export function getMaterialDictionaryTreeLazy(params, extra) {
  return Request.http.get('/materialdictionary/nodeSubTreeList', params, extra);
}
//物料字典 添加节点
export function addMaterialDictionaryTree(params, extra) {
  return Request.http.post('/materialdictionary/add', params, extra);
}
//物料字典 获取业务属性
export function getMaterialDictionaryBusinessType(params, extra) {
  return Request.http.get('/materialdictionary/getBusinessType', params, extra);
}
//物料字典 获取节点详情
export function getMaterialDictionaryInfo(params, extra) {
  return Request.http.get('/materialdictionary/getMaterialDictInfo', params, extra);
}
//物料字典 删除节点
export function deleteMaterialDictionary(params, extra) {
  return Request.http.get('/materialdictionary/delete', params, extra);
}
//物料字典 提交编辑
export function editMaterialDictionary(params, extra) {
  return Request.http.post('/materialdictionary/modify', params, extra);
}
//物料字典 启用禁用
export function enabledMaterialDictionary(params, extra) {
  return Request.http.get('/materialdictionary/lockMaterialDictionary', params, extra);
}
// 重量单位
export function getWeightList(params, extra) {
  return Request.http.get('/dict/getWeightList', params, extra);
}
//  计量单位
export function getMeasurementList(params, extra) {
  return Request.http.get('/dict/getMeasurementList', params, extra);
}


// 工作分解结构 查询部位下的清单列表
export function subWorkEngineeringList(params, extra) {
  return Request.http.get('/resourcesLedger/subWorkEngineeringList', params, extra);
}

// 工作清单 查询部位下的清单列表
export function queryWorkResolvesOfEngineering(params, extra) {
  return Request.http.get('/resourcesLedger/queryWorkResolvesOfEngineering', params, extra);
}

//  资源台账添加  post
export function batchAdd(params, extra) {
  return Request.http.post('/resourcesLedger/batchAdd', params, extra);
}

//  资源台账编辑 post  参数
export function resourcesLedgerModify(params, extra) {
  return Request.http.post('/resourcesLedger/modify', params, extra);
}

//   资源台账删除 get  参数 资源台账id resourcesLedgerId
export function resourcesLedgerDelete(params, extra) {
  return Request.http.get('/resourcesLedger/delete', params, extra);
}

//   根据id查询物资 get  resourcesLedgerId资源台账id
export function getResourcesLedger(params, extra) {
  return Request.http.get('/resourcesLedger/getResourcesLedger', params, extra);
}

//  get * @param engineeringId 清单id * @param workResolveId 部位id
export function getResourcesLedgerList(params, extra) {
  return Request.http.get('/resourcesLedger/getResourcesLedgerList', params, extra);
}

//  新增或修改砼标号字典
export function addConcreteLabel(params, extra) {
  return Request.http.post('/concreteLabel/addConcreteLabel', params, extra);
}

//  查询单条砼标号字典
export function queryConcreteLabel(params, extra) {
  return Request.http.get('/concreteLabel/queryConcreteLabel', params, extra);
}

//  分页查询砼标号字典
export function queryConcreteLabelList(params, extra) {
  return Request.http.post('/concreteLabel/queryConcreteLabelList', params, extra);
}

// 删除砼标号字典
export function deleteConcreteLabel(params, extra) {
  return Request.http.get('/concreteLabel/deleteConcreteLabel', params, extra);
}

//获取七牛token  (public)
export function getQiniuPublicToken(params, extra) {
  return Request.http.get('/file/publicToken', params, extra);
}

//获取七牛token  (private)
export function getQiniuPrivateToken(params, extra) {
  return Request.http.get('/file/privateToken', params, extra);
}

//提交新增合同
export function contractAdd(params, extra) {
  return Request.http.post('/contract/addOrModify', params, extra);
}

//获取合同列表
export function getContractList(params, extra) {
  return Request.http.post('/contract/pageRecord', params, extra);
}

//获取合同详情
export function getContractDetail(params, extra) {
  return Request.http.get('/contract/detail', params, extra);
}

//删除合同
export function contractDelete(params, extra) {
  return Request.http.get('/contract/delete', params, extra);
}

//获取合同的甲方
export function getPlanA(params, extra) {
  return Request.http.get('/contract/querySubCompanyProjectTree', params, extra);
}

//导入台账到某个节点下
export function importNodeZeroLedgerExcel(params, extra) {
  return Request.http.post('/zeroLedger/importNodeZeroLedgerExcel', params, extra);
}

//物料字典  是否过磅
export function dictionarySetWeightStatus(params, extra) {
  return Request.http.get('/materialdictionary/setWeightStatus', params, extra);
}

//物料字典
export function queryMaterialDictionaryLikeName(params, extra) {
  return Request.http.get('/materialdictionary/queryMaterialDictionaryLikeName', params, extra);
}

// 设置的接口
export function setSwitchByProject(params, extra) {
  return Request.http.post('/proj/setSwitchByProject', params, extra);
}

//获取项目的组织架构
export function queryOrgTreeOfProject(params, extra) {
  return Request.http.get('/organize/queryOrgTreeOfProject', params, extra);
}



// WEBPACK FOOTER //
// ./src/api/api.js